/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

export enum LanguageChangeSource {
    Automatic = 'AUTOMATIC',
    Manual = 'MANUAL'
}

export interface LanguageOverride {
    languageCode: string;
    languageChangeSource: LanguageChangeSource;
}
